import { createActions } from 'redux-actions';

export const actions = createActions({
  SIMULATOR: {
    COMPARE: boolean => boolean,
    SET_TOTAL_YEARS: data => data,
    SET_CURRENT_ITEM: data => data,
  },
}).simulator;
